import { useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'
import { RootState } from 'store'

export function useIsBoAdminRole() {
  const roles = useSelector((state: RootState) => state.account.roles)
  return roles?.includes('bo_admin')
}
